import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import Swal from 'sweetalert2';
import {parse as parseMoney} from 'vue-currency-input';
import {getField, updateField} from 'vuex-map-fields';
import moment from 'moment';

import {localize as veeLocalize} from 'vee-validate/dist/vee-validate.full';

import banklist from '../mfobanklist.json';

Vue.use(Vuex);

const saveDataDefaultValues = {
  ubd: '',
  risks: [],
  epites: [],
  tab_id: '1',
  endingMessageReceived: false,
  targya: 'ingatlan_ingosag',
  baleset: [],
  fizikai: '0',
  processfinished: false,
  szormek: 0,
  ekszerek: 0,
  eves_dij: 46857,
  foepulet: {
    alap_dij: 32407,
    cim_kategoria: '1',
    potdij_szorzo: [],
    teljes_osszeg: 32406400,
    ajl_min_osszeg: 41000000,
    dijtetel_szorzo: 0.7904,
    ingatlan_ajl_m2ar: 410,
  },
  risks: [],
  sportok: [],
  limitek: [],
  processfinished: false,
  endingMessageReceived: false,
  keszpenz: '0',
  brokerkod: '',
  brokernev: '',
  kegyeleti: '0',
  telepules: '',
  mezogazdasag: [],
  assistance: [],
  epites_eve: '',
  ertektargy: '0',
  gyujtemeny: 0,
  ingosagokA: 0,
  issue_date: '',
  kockazatok: [],
  kulterulet: '0',
  szormekdij: 0,
  vaningosag: '',
  alapterulet: '0',
  balesetdijA: '',
  ekszerekdij: 0,
  engedmenyek: [],
  lakok_szama: '0',
  // merchant_id: 'colo213',
  merchant_id: '',
  sporteszkoz: [],
  storage_uid: '',
  tulajdonjog: '',
  vandalizmus: [],
  vizkarextra: [],
  zoldenergia: [],
  country_code: '',
  ertekosszdij: '',
  generatelink: '',
  iranyitoszam: '',
  mellekepulet: [],
  product_code: '',
  partnertipus: '',
  allatallomany: [],
  antik_butorok: 0,
  antiktargydij: 0,
  balesetlimitA: '',
  cim_kategoria: '',
  eves_dij_alap: 0,
  eves_dij_kieg: 0,
  eves_dij_plus: 0,
  foepulet_teto: '',
  gyakorisagdij: 0,
  gyujtemenydij: 0,
  kegyeleti_dij: '',
  keszpenz_kieg: [],
  allando_lakott: '',
  foepulet_ajl_A: 0,
  ingatlan_tipus: '',
  kepzomuveszeti: 0,
  kiemeltingosag: '0',
  mellekepuletek: '',
  termes_termeny: [],
  utasbiztositas: [],
  alapdijosszesen: 0,
  ingatlan_erteke: '',
  ingosag_alapdij: 14450,
  kegyeleti_limit: '',
  kulonleges_uveg: '0',
  zaradek_szovege: [],
  foepulet_falazat: '',
  ingosag_osszesen: 0,
  kegyeleti_tipusa: '',
  szabadban_tarolt: [],
  allatallomany_dij: '',
  allatallomany_van: '',
  berloi_felelosseg: [],
  biztositas_targya: '',
  gepek_felszereles: [],
  ingatlan_jelzalog: '0',
  ingatlanalapdij_A: 0,
  kepzomuveszetidij: 0,
  engedmeny_osszesen: 0,
  engedmeny_szazalek: 0,
  foepulet_alapdij_A: 0,
  kiemeltingosag_dij: '',
  mellekepulet_ajl_A: 0,
  nyilatkozat_szoveg:
    'a Biztosító a Colonnade Minősített Fogyasztóbarát Otthonbiztosítás termékkel kapcsolatosan nem nyújt tanácsadást, a termék értékesítése pedig közvetlenül a biztosító online értékesítési felületén keresztül történik, az értékesítési folyamatban biztosításközvetítő nem működik közre.',
  termes_termeny_dij: '',
  termes_termeny_van: '',
  utas_biztositottak: '',
  utasbiztositas_dij: 0,
  ertektargy_osszesen: 0,
  ingatlan_ajanlott_A: 0,
  altalanos_felelosseg: '',
  eves_dij_csokkentett: 0,
  ingatlan_valaszott_A: 0,
  kiemeltingosag_limit: '',
  mellekepulet_ingosag: 0,
  mellekepuletek_descr: '',
  mellekepuletek_szama: 0,
  gepek_felszereles_dij: '',
  gepek_felszereles_van: '',
  ingosag_potdij_szorzo: 0,
  kiemeltingosag_osszeg: '',
  ingo_ingatlan_alapdijA: 0,
  ingosagok_ajanlott_arA: 0,
  ingosagok_ajanlott_arF: 0,
  ingosagok_ajanlott_arM: 0,
  kerti_veszelytelenites: [],
  mellekepulet_alapdij_A: 0,
  ingosag_dijtetel_szorzo: 1.7,
  utasbiztositottak_szama: 0,
  temetesbiztositottak_szama: 0,
  balesetbiztositas_tipusa: '',
  mellekepuletek_teljes_m2: 0,
  valasztott_ar_mellekepulet: 0,
  ajanlott_bizt_osszeg_elfogad: '',
};

function replaceUrlParam(url, paramName, paramValue) {
  if (paramValue == null) {
    paramValue = '';
  }
  var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, '$1' + paramValue + '$2');
  }
  url = url.replace(/[?#]$/, '');
  return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
}

function removeUnusedPropertyFromSaveData(data, defaultData) {
  let filteredData = JSON.parse(JSON.stringify(data));

  for (const [key, value] of Object.entries(data)) {
    if (value === defaultData[key] || Object.keys(value).length === 0) {
      delete filteredData[key];
    }
  }
  //console.log('data filterutén');
  //console.log(filteredData);
  return filteredData;
}
function findValueByKey(obj, key) {
  // Check if the key exists in the current object
  if (key in obj) {
    return obj[key];
  }

  // Iterate through the properties of the object
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      const value = obj[prop];
      if (typeof value === 'object') {
        // Recursively search within nested objects
        const nestedValue = findValueByKey(value, key);
        if (nestedValue !== undefined) {
          return nestedValue;
        }
      }
    }
  }

  // Key not found
  return undefined;
}

function findAndSumNestedKey(obj, keyToFind) {
  let sum = 0;

  function findKey(obj) {
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (typeof obj[prop] === 'object') {
          findKey(obj[prop]);
        } else if (prop === keyToFind) {
          // Check if the value is a number represented as a string
          const value = obj[prop];
          if (!isNaN(value)) {
            sum += parseFloat(value);
          }
        }
      }
    }
  }

  findKey(obj);

  return sum;
}

const getDefaultState = () => {
  return {
    page: 1,
    endingMessageReceived: false,
    formSubmitLoading: false,
    generalErrors: [],
    //storage_uid: localStorage.getItem('storage_uid') || null,
    //last_interaction: localStorage.getItem('last_interaction') || new Date(),
    storage_uid: null,
    last_interaction: new Date(),
    endingMessageReceived: false,
    canProceedToNextPage: true,
    dm: false,
    processfinished: false,
    ertekesito_koti: false,
    dm_email_sent: false,
    code: false,
    generatelink: 0,
    save_request_uid: '',
    connection: 'conncetion',
    fetch_url: null,
    MFOLoaded: false,
    cities: [],
    product_code: '',
    partnertipus: '',
    sportok: [],
    limitek: [],
    eves_dij_plus: 0,
    kieg_emelt_eves_dij: 0,
    kieg_kedv_dij: 0,
    gyakorisag_dij_havi: 0,
    gyakorisag_szerint_fizetendo_dij: 0,
    email_valid_code: null,
    last_email: null,
    igeny_azon_href: null,
    // merchant_id: null,
    merchant_id: 'nsu',
    engedmenyek: {},
    isBackButtonDisabled: false,

    mainBuildingInsuranceChanged: false,
    sideBuildingInsuranceChanged: false,
    allGoodsPriceChanged: false,
    contractorPropertyZipChanged: false,
    contractorPropertyName: 'Hibás irányítószám',
    processfinished: false,
    marks: {},
    banks: banklist,
    generalInfo: {
      privatePerson: 1,
      contractFor: 1,
      isAgent: 0,
      agentId: '',
      propertyType: 'tarsashaz',
      propertyInhabitated: 1,
      propertyOutskirts: 0,
      propertyPhysicalJob: 0,
      propertyPhysicalJobName: '',
      propertyOwnRight: 'sajat',
      propertyZip: '',
      propertyName: '',
      selectedPropertyName: null,
      contractorVat: null,
      chosenSport: '',
      chosenPackage: '',
    },
    sportNames: {
      roplabda: 'Röplabda',
      atletika: 'Atlétika',
      jegkorong: 'Jégkorong',
      kezilabda: 'Kézilabda',
      kosarlabda: 'Kosárlabda',
      labdarugas: 'Labdarúgás',
      tenisz: 'Tenisz',
      uszas: 'Úszás',
      vivas: 'Vívás',
      vizilabda: 'Vízilabda',
      egyeb: 'Egyéb sport',
    },
    packageNames: {
      alap: 'Alap csomag',
      kozepes: 'Közepes csomag',
      kiemelt: 'Kiemelt csomag',
    },
    insuranceProperty: {
      floorArea: '',
      recommendedInsurancePrice: 0,
      chosenInsurancePrice: '',
      builtYear: '',
      residents: 1,
      wallType: 'tegla',
      roofType: 'cserep',
    },
    insuranceSideBuildings: {
      template: {
        floorArea: '',
        wallType: 'tegla',
        roofType: 'cserep',
      },
      list: [],
      recommendedInsurancePrice: 0,
      chosenInsurancePrice: '',
    },
    insurancePersonalGoods: {
      calculatedInsurancePrice: 0,
      acceptCalculatedInsurance: 1,
      allGoodsPrice: 0,
    },
    chooseableAccesories: {
      valuablesAbove200: false,
      valuesAbove200Minimum: 200000,
      valuesAbove200Maximum: 20000000,
      valuesAbove200Sum: 0,
      valuablesAboveInputs: {
        jewelry: 0,
        antiques: 0,
        exotic: 0,
        collection: 0,
        fineart: 0,
      },
      selectableList: {
        ertektargy: {
          selected: false,
          onlyLiving: true,
          name: 'Értéktárgyak',
          insurancePrice: 'Kötvény alapján',
          insuranceFee: 0,
          showable: [1, 3],
        },
        kiemeltingosag: {
          selected: false,
          onlyLiving: true,
          name: 'Kiemelt ingóság',
          insurancePrice: 'Kötvény alapján',
          insuranceFee: 0,
          showable: [1, 3],
        },
        keszpenz: {
          selected: false,
          onlyLiving: true,
          name: 'Készpénz',
          insurancePrice: 'biztosítási összeg: 200 000 Ft',
          insuranceFee: 2100,
          showable: [1, 3],
        },
        kulonleges_uveg: {
          selected: false,
          name: 'Különleges üveg',
          insurancePrice: 'biztosítási összeg: 300 000 Ft',
          insuranceFee: 3500,
          showable: [1],
        },
        epites: {
          selected: false,
          name: 'Építés, szerelésbiztosítás',
          insurancePrice: 'biztosítási összeg: 1 000 000 Ft',
          insuranceFee: 5000,
          showable: [1, 2],
        },
        epulet_hiba: {
          selected: false,
          name: 'Lakóépületek rejtett hibáiból eredő károk',
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        assistance: {
          selected: false,
          name: 'Asszisztencia',
          insurancePrice: 'biztosítási összeg: 50 000 Ft',
          insuranceFee: 4000,
          customEnding: ' /3 alkalom/időszak',
          showable: [1, 2],
        },
        epulettartozek_lopas: {
          selected: false,
          name: 'Épülettartozékok lopása',
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        klima: {
          selected: false,
          name: 'Klímaberendezés biztosítás',
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        szabadban_tarolt: {
          selected: false,
          name: 'Szabadban tárolt vagyontárgy',
          insurancePrice: 'biztosítási összeg: 300 000 Ft',
          insuranceFee: 5500,
          showable: [1, 3],
        },
        allo_noveny: {
          selected: false,
          name: 'Lábon álló növényzet biztosítása',
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        sporteszkoz: {
          selected: false,
          name: 'Sporteszköz és sportfelszerelés',
          insurancePrice: 300000,
          insuranceFee: 5500,
          showable: [1, 3],
        },
        kisallat: {
          selected: false,
          name: 'Hobbi- és kisállatbiztosítás',
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        kegyeleti: {
          selected: false,
          name: 'Temetés költségeinek térítése',
          insurancePrice: 'biztosítási összeg: 150 000 Ft / 300 000 Ft / 500 000 Ft',
          insuranceFee: '<b>3 000 Ft</b> / <b>6 000 Ft</b> / <b>10 000 Ft</b> /év',
          showable: [1, 2, 3],
        },
        garancia: {
          selected: false,
          name: 'Kiterjesztett garancia',
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        okos_eszkoz: {
          selected: false,
          name: 'Okos eszközök biztosítás (beleértve okos otthon eszközök)',
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        berleti_dij: {
          selected: false,
          name: 'Elmaradt bérleti díj biztosítás',
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        baleset: {
          selected: false,
          name: 'Balesetbiztosítás',
          insurancePrice: 'biztosítási összeg: 500 000 Ft / 1 000 000 Ft',
          insuranceFee: '<b>5 000 Ft vagy 10 000 Ft</b> /év',
          showable: [1, 2, 3],
        },
        munkanelkuliseg: {
          selected: false,
          name: 'Munkanélküliségi biztosítás',
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        felelosseg: {
          selected: false,
          name: 'Felelősség biztosítás',
          insurancePrice: 'biztosítási összeg: 40 000 000 Ft / 1 000 000 Ft',
          insuranceFee: '<b>5 400 Ft / 10 000 Ft</b> /év',
          showable: [1, 2, 3],
        },
        zoldenergia: {
          selected: false,
          name: 'Zöld energia',
          insurancePrice:
            'biztosítási összeg: Napkollektor, napelem: 3 000 000 Ft + Hőszivattyú: 500 000 Ft',
          insuranceFee: 6000,
          showable: [1, 2],
        },
        kerti_veszelytelenites: {
          selected: false,
          name: 'Kerti veszélytelenítés',
          insurancePrice: 'biztosítási összeg: 200 000 Ft',
          insuranceFee: 2000,
          showable: [1, 2],
        },
        mezogazdasag: {
          selected: false,
          name: 'Mezőgazdasági kiegészítés', // 3 opció, beírható összegekkel (kb mint az értéktárgyak)
          insurancePrice: 'Kötvény alapján, kategóriánként maximum 1 000 000 Ft',
          insuranceFee: 0,
          showable: [1, 3],
        },
        vandalizmus: {
          selected: false,
          name: 'Vandalizmus',
          insurancePrice: 'biztosítási összeg: 300 000 Ft',
          insuranceFee: 4200,
          showable: [1, 2],
        },
        vizkarextra: {
          selected: false,
          name: 'Vízkár extra (szaniter)',
          insurancePrice: 'biztosítási összeg: 250 000 Ft',
          insuranceFee: 15000,
          showable: [1],
        },
        utasbiztositas: {
          selected: false,
          name: 'Utasbiztosítás',
          insurancePrice: 'biztosítási összeg: 6 000 000 Ft/esemény, / 12 000 000 Ft',
          insuranceFee: '<b>4 500 Ft</b> /fő/év',
          showable: [1, 2, 3],
        },
      },
      travelInsuranced: {
        template: {
          name: null,
          bornDate: null,
        },
        list: [],
      },
      burialInsuranced: {
        template: {
          name: null,
          bornDate: null,
        },
        list: [],
      },
      personTemplate: {
        name: null,
        bornDate: null,
      },
      funeralPrice: 150000,
      generalLiability: true,
      landlordLiability: false,
      farmingStock: 0,
      farmingAnimals: 0,
      farmingTools: 0,
      priorityProperty: 0,
      accidentInsuranceType: 'standard',
      accessorySumPrice: 0,
    },
    paymentOptions: {
      type: 'online',
      frequency: 'eves',
    },
    kotes_oka: 'atkotes',
    regi_kotvenyszam: '',

    electronicContact: 1,
    electronicInsuring: 1,
    ageDiscount: 1,
    couponCode: '',
    riskSettings: {
      startDate: moment(new Date().setDate(new Date().getDate() + 1)).format('YYYY-MM-DD'),
      locationZip: '',
      locationCity: '',
      locationName: '',
      locationType: '',
      locationHouseNumber: '',
      locationBuilding: '',
      locationTopography: '',

      companyLocationZip: '',
      companyLocationCity: '',
      companyLocationName: '',
      companyLocationType: '',
      companyLocationHouseNumber: '',
      companyLocationBuilding: '',
    },
    contractSettings: {
      gender: '',
      lastName: '',
      companyName: '',
      firstName: '',
      motherChildName: '',
      bornName: '',
      bornCity: '',
      bornDate: '',
      phoneNumberArea: '',
      phoneNumber: '',
      email: '',
      emailVerification: '',
      emailVerified: false,
      emailVerifyToken: '',
      merchantEmail: '',
      postAddressIsTheSame: 1,
      postAddress: {
        locationZip: '',
        locationCity: '',
        locationName: '',
        selectedLocationName: null,
        locationType: '',
        locationHouseNumber: '',
        locationBuilding: '',
        locationTopography: '',
      },
    },
    insuredSettings: {
      contractedIsInsured: 1,
      gender: '',
      lastName: '',
      firstName: '',
      motherChildName: '',
      bornName: '',
      bornCity: '',
      bornDate: '',
      phoneNumberArea: '',
      phoneNumber: '',
      email: '',
      emailVerification: '',
    },
    mortgageSettings: {
      propertyIsMortgaged: 0,
      creditor: '',
      creditorLocation: '',
      mortgageId: '',
      mortgagePrice: 0,
      mortgageCurrency: 'HUF',
      mortgageStartDate: null,
      mortgageEndDate: null,
    },
    statementSettings: {
      privacyStatement: false,
      privacyProtection: false,
      insuranceTerms: false,
      electronicCommunation: false,
      marketingMails: false,
      acceptTerms: false,
      validMerchant: false,
      validDatas: false,
      contrctReasonStatement: false,
    },
  };
};

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  state: getDefaultState(),

  getters: {
    getField,
    getAllState: (state) => {
      const doNotIncludeArray = [
        //'save_request_uid',
        'canProceedToNextPage',
        'storage_uid',
        'mainBuildingInsuranceChanged',
        'sideBuildingInsuranceChanged',
        'eves_dij_plus',
        'gyakorisag_dij_havi',
        'gyakorisag_szerint_fizetendo_dij',
        'last_interaction',
        'generalErrors',
        'allGoodsPriceChanged',
        'marks',
        'engedmenyek',
        'email_valid_code',
        'last_email',
        'contractorPropertyZipChanged',
        'contractorPropertyName',
        'formSubmitLoading',
        'igeny_azon_href',
        'merchant_id',
        'banks',
        'MFOLoaded',
        'cities',
      ];
      const filtered = Object.keys(state)
        .filter((key) => !doNotIncludeArray.includes(key))
        .reduce((obj, key) => {
          obj[key] = state[key];
          return obj;
        }, {});

      return filtered;
    },
    getDiscountSum: (state) => {
      let total = 0;
      for (const key in state.engedmenyek) {
        if (state.engedmenyek.hasOwnProperty(key)) {
          total += state.engedmenyek[key];
        }
      }
      return total * -1;
    },
    getRisks: (state) => {
      let exceptions = ['P040', 'P042', 'P043', 'P044', 'P046', 'P002', 'P017', 'P045'];
      let accessoryFound = false;
      let accesoriosAr = [];
      for (const key in state.risks) {
        if (exceptions.includes(key)) continue;

        let risk = findValueByKey(state.risks[key], 'risks');
        let price = findValueByKey(state.risks[key], 'dij');
        if (key === 'T001') {
          let filteredDesc = state.risks[key].desc.split(',')[0];
          accesoriosAr.push({
            item_id: key,
            item_name: filteredDesc, //ez legyen a kiegészítő fedezet neve
            affiliation: 'Household NOPA',
            coupon: state.couponCode,
            discount: 'Na', //Ez legyen 'Na', mert nincs egyenként
            price: price, //az adott kieg fedezet ára
            item_brand: 'Colonnade',
            item_category: 'Household',
          });
        } else {
          accesoriosAr.push({
            item_id: key,
            item_name: key === 'P200'.toString() ? 'Kézpénz' : state.risks[key].desc, //ez legyen a kiegészítő fedezet neve
            affiliation: 'Household NOPA',
            coupon: state.couponCode,
            discount: 'Na', //Ez legyen 'Na', mert nincs egyenként
            price: price, //az adott kieg fedezet ára
            item_brand: 'Colonnade',
            item_category: 'Household',
          });
        }
      }
      if (state?.ertektargy_osszesen) {
        accesoriosAr.push({
          item_id: 'P040-P042-P043-P044-P046-P045',
          item_name: 'Értéktárgyak összesen', //ez legyen a kiegészítő fedezet neve
          affiliation: 'Household NOPA',
          coupon: state.couponCode,
          discount: 'Na', //Ez legyen 'Na', mert nincs egyenként
          price: state.ertektargy_osszesen, //az adott kieg fedezet ára
          item_brand: 'Colonnade',
          item_category: 'Household',
        });
      }
      return accesoriosAr;
    },
    getProductDetails: (state) => (idArr) => {
      let detailsArr = [];
      for (const id in idArr) {
        if (idArr[id] in state.risks) {
          detailsArr.push({
            item_id: idArr[id],
            item_name: state.risks[idArr[id]].desc,
          });
        }
      }
      return detailsArr;
    },
    getMainBuildingDetails: (state) => (riskCode) => {
      let mainBuildingArr = state.risks[riskCode]?.desc.split(',');

      if (mainBuildingArr) {
        return {
          area: mainBuildingArr[0],
          wallType: mainBuildingArr[1],
          roofType: mainBuildingArr[2],
        };
      } else {
        return {
          area: 'none',
          wallType: 'none',
          roofType: 'none',
        };
      }
    },
    getSideBuildingsDetails: (state) => (riskCode) => {
      let sideBuildinDetalis = [];
      if (state.risks[riskCode]?.desc) {
        let sideBuildingRiskArr = state.risks[riskCode].desc.slice(0, -1).split(';');
        for (let i = 1; i <= sideBuildingRiskArr.length; i++) {
          const sideArr = sideBuildingRiskArr[i - 1].split(',');
          sideBuildinDetalis.push({
            ['sideBuilding' + i]: {
              area: sideArr[0].split(':')[1] + 'm2',
              wallType: sideArr[1].split(':')[1],
              roofType: sideArr[2].split(':')[1],
            },
          });
        }
      }

      return sideBuildinDetalis;
    },
    getAccesories: (state) => {
      let accesoriosAr = [];
      let defaultArr = [
        {
          item_id: 'No Accesories',
          item_name: 'No Accesories', //ez legyen a kiegészítő fedezet neve
          affiliation: '',
          coupon: '',
          discount: 'Na', //Ez legyen 'Na', mert nincs egyenként
          price: 0, //az adott kieg fedezet ára
          item_brand: '',
          item_category: '',
        },
      ];
      for (const key in state.chooseableAccesories.selectableList) {
        if (state.chooseableAccesories.selectableList[key].selected) {
          accesoriosAr.push({
            item_id: state.product_code,
            item_name: state.chooseableAccesories.selectableList[key].name, //ez legyen a kiegészítő fedezet neve
            affiliation: 'Household NOPA',
            coupon: state.couponCode,
            discount: 'Na', //Ez legyen 'Na', mert nincs egyenként
            price: state.chooseableAccesories.selectableList[key].insuranceFee, //az adott kieg fedezet ára
            item_brand: 'Colonnade',
            item_category: 'Household',
          });
        }
      }
      if (accesoriosAr.length < 1) {
        return defaultArr;
      } else {
        return accesoriosAr;
      }
    },
  },
  mutations: {
    updateField,
    resetState(state) {
      localStorage.clear();
      Object.assign(state, getDefaultState());
    },
    incrementPage(state, value = null) {
      if (value !== null) {
        state.page = value;
      } else if (!value && state.page < 5) {
        state.page++;
      }
      window.scrollTo(0, 0);
    },
    decrementPage(state, value = null) {
      if (value !== null) {
        state.page = value;
      } else if (!value && state.page > 1) {
        state.page--;
      }

      window.scrollTo(0, 0);
    },
    setConnection(state, value) {
      state.connection = value;
    },
    setCities(state, cities) {
      state.cities = cities;
    },
    setProductCode(state, code) {
      state.product_code = code;
    },
    setFormSubmitLoading(state, status) {
      state.formSubmitLoading = status;
    },
    addSideBuilding(state, building) {
      state.insuranceSideBuildings.list.push(building);
    },
    deleteSideBuilding(state, id) {
      state.insuranceSideBuildings.list.splice(id, 1);
    },
    updateSideBuilding(state, data) {
      const index = state.insuranceSideBuildings.list.findIndex(
        (item, index) => index === data.building
      );
      if (index !== -1) state.insuranceSideBuildings.list[index][data.key] = data.value;
    },
    updateAccesory(state, data) {
      const index = state.chooseableAccesories.selectableList[data.key];
      if (index) state.chooseableAccesories.selectableList[data.key].selected = data.value;
    },

    setMFOLoadedStatus(state, status) {
      state.MFOLoaded = status;
    },

    // insured persons

    addInsuredPerson(state, data) {
      state.chooseableAccesories[data.listName].list.push(data.person);
    },
    deleteInsuredPerson(state, data) {
      state.chooseableAccesories[data.listName].list.splice(data.id, 1);
    },
    updateInsuredPerson(state, data) {
      const index = state.chooseableAccesories[data.listName].list.findIndex(
        (item, index) => index === data.index
      );
      if (index !== -1)
        state.chooseableAccesories[data.listName].list[index][data.key] = data.value;
    },

    // recommended and chosen insurance prices
    setRecommendedInsurancePriceMain(state, value) {
      state.insuranceProperty.recommendedInsurancePrice = value;
    },
    setRecommendedInsurancePriceSide(state, value) {
      state.insuranceSideBuildings.recommendedInsurancePrice = value;
    },
    setRecommendedPersonalGoodsPrice(state, value) {
      state.insurancePersonalGoods.calculatedInsurancePrice = value;
    },
    setChosenInsurancePriceMain(state, value) {
      state.insuranceProperty.chosenInsurancePrice = value;
    },
    setChosenInsurancePriceSide(state, value) {
      state.insuranceSideBuildings.chosenInsurancePrice = value;
    },
    setChosenPersonalPriceSide(state, value) {
      state.insurancePersonalGoods.allGoodsPrice = value;
    },

    // insurance property town name
    setInsurancePropertyTownName(state, name) {
      state.generalInfo.propertyName = name;
    },
    setContractPostPropertyTownName(state, name) {
      state.contractSettings.postAddress.locationCity = name;
      state.contractorPropertyName = name;
    },
    setCompanyTownName(state, name) {
      state.riskSettings.companyLocationCity = name;
    },

    // update main and side building insurance input state
    setMainInsuranceChangedState(state, value) {
      state.mainBuildingInsuranceChanged = value;
    },
    setSideInsuranceChangedState(state, value) {
      state.sideBuildingInsuranceChanged = value;
    },
    setAllGoodsPriceChangedState(state, value) {
      state.allGoodsPriceChanged = value;
    },
    setRisks(state, value) {
      state.risks = value;
    },
    setSportok(state, value) {
      state.sportok = value;
    },
    setSportokNeve(state, value) {
      state.sportNames = value;
    },
    setLimitek(state, value) {
      state.limitek = value;
    },

    setErtektargyOsszesen(state, value) {
      state.ertektargy_osszesen = value;
    },
    setCouponCode(state, value) {
      state.couponCode = value;
    },
    setPartnertipus(state, value) {
      state.partnertipus = value;
    },

    // page allowing
    setNextPageStatus(state, status) {
      const now = new Date();
      const ONE_HOUR = 60 * 60 * 1000;
      // const ONE_HOUR = 2;

      const date = new Date(state.last_interaction);
      if (now - date > ONE_HOUR * 2) {
        this.commit('setStorageUid', null);
      }
      state.last_interaction = now;
      localStorage.setItem('last_interaction', now);
      state.canProceedToNextPage = status;
    },

    // set yearly price
    setYearlyPrice(state, price) {
      state.chooseableAccesories.accessorySumPrice = price;
    },

    setPlusAccesoriesPrice(state, price) {
      state.eves_dij_plus = price;
    },
    setFrequencyPrice(state, price) {
      state.gyakorisag_szerint_fizetendo_dij = price;
    },
    setMonthlyPrice(state, price) {
      state.gyakorisag_dij_havi = price;
    },

    setYearlyPriceWithAccesories(state, price) {
      state.kieg_emelt_eves_dij = price;
    },

    setYearlyPriceWithDiscounts(state, price) {
      state.kieg_kedv_dij = price;
    },

    setDiscounts(state, discounts) {
      state.engedmenyek = discounts;
    },

    // set max valuables above 200
    setMaxValuablesPrice(state, price) {
      state.chooseableAccesories.valuesAbove200Maximum = price;
    },

    // set email validation code
    setEmailValidationCode(state, {code, email}) {
      state.email_valid_code = code;
      state.last_email = email;
    },

    setEndingMessageReceived(state, value) {
      state.endingMessageReceived = true;
    },
    // storage uid
    setStorageUid(state, uid) {
      if (!uid) {
        state.storage_uid = null;
        //localStorage.removeItem('storage_uid');
      } else {
        state.storage_uid = uid;
        //localStorage.setItem('storage_uid', uid);
      }
    },
    setClaimIdentifierUrl(state, url) {
      state.igeny_azon_href = url;
    },
    setGenerateLink(state, value) {
      state.generatelink = value;
    },

    // update values on load
    setGeneralPropertyValues(state, {name, value}) {
      if (state.generalInfo[name] != undefined) state.generalInfo[name] = value;
    },

    setDmType(state, value) {
      state.dm = value;
    },
    setErtekesitoKoti(state, value) {
      state.ertekesito_koti = value;
    },
    setCityName(state, value) {
      state.generalInfo.selectedPropertyName = value;
    },
    setInsurancePropertyValues(state, {name, value}) {
      if (state.insuranceProperty[name] != undefined) state.insuranceProperty[name] = value;
    },

    setInsuranceSidePropertyValues(state, {name, value}) {
      if (state.insuranceSideBuildings[name] != undefined)
        state.insuranceSideBuildings[name] = value;
    },

    setInsurancePersonalGoods(state, {name, value}) {
      if (state.insurancePersonalGoods[name] != undefined)
        state.insurancePersonalGoods[name] = value;
    },

    setChooseableAccesoriesSelected(state, {name, value}) {
      if (state.chooseableAccesories.selectableList[name] != undefined)
        state.chooseableAccesories.selectableList[name].selected = value;
    },

    setChooseableAccesories(state, {name, value}) {
      if (state.chooseableAccesories[name] != undefined) state.chooseableAccesories[name] = value;
    },

    setValuablesAboveInputs(state, {name, value}) {
      if (state.chooseableAccesories.valuablesAboveInputs[name] != undefined)
        state.chooseableAccesories.valuablesAboveInputs[name] = value;
    },

    setPaymentOptions(state, {name, value}) {
      if (state.paymentOptions[name] != undefined) state.paymentOptions[name] = value;
    },
    setContraceReason(state, value) {
      state.kotes_oka = value;
    },

    setOldBondnumber(state, value) {
      state.regi_kotvenyszam = value;
    },
    setElectronicContact(state, value) {
      state.electronicContact = value;
    },

    setElectronicInsuring(state, value) {
      state.electronicInsuring = value;
    },
    setAgeDiscount(state, value) {
      state.ageDiscount = value;
    },

    updateRiskSettings(state, {name, value}) {
      if (state.riskSettings[name] != undefined) state.riskSettings[name] = value;
    },

    updateContractSettings(state, {name, value}) {
      if (state.contractSettings[name] != undefined) state.contractSettings[name] = value;
    },

    updateContractPostSettings(state, {name, value}) {
      if (state.contractSettings.postAddress[name] != undefined)
        state.contractSettings.postAddress[name] = value;
    },

    updateInsuredSettings(state, {name, value}) {
      if (state.insuredSettings[name] != undefined) state.insuredSettings[name] = value;
    },

    updateMortgageSettings(state, {name, value}) {
      if (state.mortgageSettings[name] != undefined) state.mortgageSettings[name] = value;
    },

    updateStatements(state, {name, value}) {
      if (state.statementSettings[name] != undefined) state.statementSettings[name] = value;
    },

    // general errors
    setGeneralErrors(state, errors) {
      errors.forEach((error) => {
        if (!state.generalErrors.includes(error)) Vue.$toast.error(error);
      });
      state.generalErrors = errors;
    },

    setMarks(state, marks) {
      state.marks = marks;
    },
    setProcessFinished(state, value) {
      state.processfinished = value;
    },
    setBanks(state, banks) {
      state.banks = banks;
    },
    //igenyazonosito
    setClaimIdentifier(state, code) {
      state.code = code;
    },
    setDMEmailSent(state, value) {
      state.dm_email_sent = value;
    },
    setSaveURL(state, saveUid) {
      state.save_request_uid = saveUid;
      //console.log('save uid: ' + saveUid);
    },
    setNavigationBackButton(state, value) {
      state.isBackButtonDisabled = value;
    },
    setFetchUrl(state, url) {
      state.fetch_url = url;
    },
    createFetchURL2(context, fetch_uid) {
      let currentLocation = window.location;
      let fetchUrl = '';
      if (currentLocation.search) {
        // window.location.href =
        //   currentLocation.origin + '/' + currentLocation.search + '&fetch_uid=' + fetch_uid;
        fetchUrl = replaceUrlParam(currentLocation.href, 'fetch_uid', fetch_uid);
        //console.log(currentUrl.search);
      } else {
        fetchUrl = currentLocation.origin + '/?fetch_uid=' + fetch_uid;
        //console.log('nincs search param');
      }
      //console.log(currentLocation);
      context.commit('setFetchUrl', fetchUrl);
    },
  },

  actions: {
    getMarks(context) {
      const params = new URLSearchParams();

      params.append('marks', 1);

      axios
        .post(`${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`, params)
        .then((res) => {
          const data = res.data.data;
          if (data?.marks) {
            context.commit('setMarks', data.marks);
            context.commit('setConnection', data.connection);
            context.dispatch('updateMarks', data.marks);

            if (data.marks.colonnade_version && context.state.page === 1) {
              Swal.fire({
                icon: 'info',
                html: `Verzió: ${data.marks.colonnade_version}`,
                showCloseButton: true,
                showConfirmButton: false,
                closeButtonAriaLabel: 'X Ablak bezárása',
              });
            }
          }

          if (data?.sportok) {
            let sportok = data.sportok;
            delete sportok['egyeb'];
            sportok.egyeb = 'olcso';
            context.commit('setSportok', sportok);
          }
          if (data?.sportok_neve) {
            context.commit('setSportokNeve', data.sportok_neve);
          }
          if (data?.limitek) {
            context.commit('setLimitek', data.limitek);
          }

          if (data?.banks) {
            context.commit('setBanks', data.banks);
          }

          if (data?.error_messages?.code) {
            veeLocalize('hu', data.error_messages);
          }
        })
        .catch((err) => {
          console.error('Nem sikerült betölteni a marks-okat.');
          console.error(err);
        });
    },
    getStoredData(context) {
      context.commit('setNextPageStatus', false);
      const state = context.state;

      const params = new URLSearchParams();
      params.append('storage_uid', state.storage_uid);

      axios
        .post(`${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`, params)
        .then((result) => {
          // console.log('előtöltés');

          if (result.data.generalErrors?.length > 0) {
            context.commit('setStorageUid', null);
            //console.log('storage_uid törölve');
            return;
          }

          const data = result.data?.labels?.result?.dump;
          if (data) {
            //console.log('getStoredData: ');
            //console.log(data);

            context.dispatch('loadStateFromData', data);

            // context.commit('setNextPageStatus', true);
          } else {
            //context.commit('setStorageUid', null)
            console.error('előtöltés sikertelen, nincs visszakapott adat');
          }
        })
        .catch((err) => {
          //console.error(err)
        });
    },
    async verifyPage(context, tab_id) {
      if (context.state.processfinished) return;
      if (context.state.endingMessageReceived) return;
      if (tab_id === 6) context.commit('setProcessFinished', true);
      if (tab_id === 6 && context.state.formSubmitLoading) return;
      context.commit('setNextPageStatus', false);
      const state = context.state;

      if (!document.getElementById('form')) return;

      const formData = new FormData(document.getElementById('form'));
      const params = new URLSearchParams();

      for (let [key, val] of formData.entries()) params.append(key, val);

      if (state.generalInfo.chosenPackage && state.generalInfo.chosenSport === 'egyeb')
        params.append('package', 'alap');

      if (tab_id) params.append('tab_id', tab_id);
      // else params.append('tab_id', state.page == 2 ? '4' : state.page);
      else params.append('tab_id', state.page);

      if (state.code) params.append('kod', state.code);

      if (state.generatelink === 1) params.append('generatelink', state.generatelink);

      let buildings = '';

      state.insuranceSideBuildings.list.forEach((building) => {
        const data = `mellekepulet_alapterulet:${building.floorArea},mellekepulet_falazat:${building.wallType},mellekepulet_tetozet:${building.roofType};`;
        buildings += data;
      });

      params.append('mellekepuletek', buildings);

      if (state.partnertipus != '') params.append('partnertipus', state.partnertipus);

      if (state.chooseableAccesories.selectableList.utasbiztositas.selected) {
        let insuredPersons = '';

        state.chooseableAccesories.travelInsuranced.list.forEach((person) => {
          let bornDate = person.bornDate;
          if (bornDate instanceof Date) {
            bornDate = bornDate.toISOString().split('T')[0];
          }

          const data = `nev:${person.name || ''},szuletesi_datum:${bornDate || ''};`;
          insuredPersons += data;
        });

        params.append('utas_biztositottak', insuredPersons);
      } else {
        params.append('utas_biztositottak', '');
      }

      if (state.chooseableAccesories.selectableList.kegyeleti.selected) {
        let insuredPersons = '';

        state.chooseableAccesories.burialInsuranced.list.forEach((person) => {
          let bornDate = person.bornDate;
          if (bornDate instanceof Date) {
            bornDate = bornDate.toISOString().split('T')[0];
          }

          const data = `nev:${person.name || ''},szuletesi_datum:${bornDate || ''};`;
          insuredPersons += data;
        });

        params.append('temetes_biztositottak', insuredPersons);
      } else {
        params.append('temetes_biztositottak', '');
      }

      if (params.has('ingatlan_erteke')) {
        let money = 0;
        try {
          money = parseMoney(
            state.insuranceProperty.chosenInsurancePrice,
            window.currencyInputOptions
          );
        } catch (e) {
          money = state.insuranceProperty.chosenInsurancePrice || 0;
        }
        params.set('ingatlan_erteke', money);
      }

      if (params.has('valasztott_ar_mellekepulet')) {
        let money = 0;
        try {
          money = parseMoney(
            state.insuranceSideBuildings.chosenInsurancePrice,
            window.currencyInputOptions
          );
        } catch (e) {
          money = state.insuranceSideBuildings.chosenInsurancePrice || 0;
        }
        params.set('valasztott_ar_mellekepulet', money || 0);
      }

      if (params.has('ingosag_osszesen')) {
        let money = 0;
        try {
          money = parseMoney(params.get('ingosag_osszesen'), window.currencyInputOptions);
        } catch (e) {
          money = parseInt(params.get('ingosag_osszesen')) || 0;
        }
        params.set('ingosag_osszesen', money);
      }

      // 2nd page
      if (params.has('ekszerek'))
        params.set(
          'ekszerek',
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.jewelry,
            window.currencyInputOptions
          ) || 0
        );
      if (params.has('antik_butorok'))
        params.set(
          'antik_butorok',
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.antiques,
            window.currencyInputOptions
          ) || 0
        );
      if (params.has('szormek'))
        params.set(
          'szormek',
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.exotic,
            window.currencyInputOptions
          ) || 0
        );
      if (params.has('gyujtemeny'))
        params.set(
          'gyujtemeny',
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.collection,
            window.currencyInputOptions
          ) || 0
        );
      if (params.has('kepzomuveszeti'))
        params.set(
          'kepzomuveszeti',
          parseMoney(
            state.chooseableAccesories.valuablesAboveInputs.fineart,
            window.currencyInputOptions
          ) || 0
        );

      if (params.has('termes_termeny'))
        params.set(
          'termes_termeny',
          parseMoney(state.chooseableAccesories.farmingStock, window.currencyInputOptions) || 0
        );
      if (params.has('allatallomany'))
        params.set(
          'allatallomany',
          parseMoney(state.chooseableAccesories.farmingAnimals, window.currencyInputOptions) || 0
        );
      if (params.has('gepek_felszereles'))
        params.set(
          'gepek_felszereles',
          parseMoney(state.chooseableAccesories.farmingTools, window.currencyInputOptions) || 0
        );

      if (params.has('kiemeltingosag_osszeg'))
        params.set(
          'kiemeltingosag_osszeg',
          parseMoney(state.chooseableAccesories.priorityProperty, window.currencyInputOptions) || 0
        );

      if (
        params.has('ph_email') &&
        params.has('ph_email_2') &&
        (!state.email_valid_code || state.last_email != state.contractSettings.email) &&
        (state.contractSettings.lastName || state.insuredSettings.lastName)
      ) {
        const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (!emailRegex.test(params.get('ph_email')) && !emailRegex.test(params.get('ph_email_2')))
          return;
        if (state.contractSettings.email === state.contractSettings.emailVerification)
          params.set('sendvalidemail', 1);
        // if (
        //   state.insuredSettings.email === state.insuredSettings.emailVerification &&
        //   state.contractedIsInsured
        // )
        //   params.set('sendvalidemail', 1);
      }

      if (params.has('biztositas_targya')) {
        const targya = params.get('biztositas_targya');

        if (targya == 'ingatlan') params.set('ingosag_osszesen', 0);
        if (targya == 'ingosag') params.set('ingatlan_erteke', 0);
      }

      // setting uid param if stored
      if (state.storage_uid) params.set('storage_uid', state.storage_uid);
      if (state.merchant_id) params.set('merchant_id', state.merchant_id);

      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params
        );

        if (tab_id === 6) context.commit('setFormSubmitLoading', false);

        // console.log('verifyPage: ');
        // console.log(result.data);
        // console.log('state:');
        // console.log(state);
        // console.log(state.storage_uid);

        let data = result.data;

        if (data.fieldErrors?.length <= 0 && data.generalErrors?.length <= 0) {
          context.commit('setNextPageStatus', true);
        }

        if (data.connection !== state.connection) {
          context.commit('setConnection', data.data.connection);
        }
        //if(data.generalErrors.includes('#T2 storage UID is null')) context.commit('incrementPage', 1)

        context.commit('setGeneralErrors', data.generalErrors);

        if (data.labels) {
          const labels = data.labels;

          if (labels?._save_request_response?.saved_request_uid) {
            context.commit('setSaveURL', labels._save_request_response.saved_request_uid);
            // context.dispatch(
            //   'navigateToSaveUrl',
            //   labels._save_request_response.saved_request_uid
            // );
            //console.log('van _save_request_uid');
            context.dispatch('createFetchURL', labels._save_request_response.saved_request_uid);
            //console.log('van _save_request_uid createFetch után');
            context.commit('setGenerateLink', 0);
            context.commit('setSaveURL', '');
          }

          if (labels.ajanlott_osszeg_foepulet) {
            context.commit('setRecommendedInsurancePriceMain', labels.ajanlott_osszeg_foepulet);
            if (!state.mainBuildingInsuranceChanged)
              context.commit('setChosenInsurancePriceMain', labels.ajanlott_osszeg_foepulet);
          }
          if (labels.ajanlott_osszeg_mellekepulet) {
            context.commit('setRecommendedInsurancePriceSide', labels.ajanlott_osszeg_mellekepulet);
            if (
              !state.sideBuildingInsuranceChanged &&
              labels.ajanlott_osszeg_mellekepulet !=
                state.insuranceSideBuildings.chosenInsurancePrice
            )
              context.commit('setChosenInsurancePriceSide', labels.ajanlott_osszeg_mellekepulet);
          }
          if (labels.ingosagok_ajanlott_ar) {
            context.commit('setRecommendedPersonalGoodsPrice', labels.ingosagok_ajanlott_ar);
            if (
              !state.allGoodsPriceChanged &&
              labels.ingosagok_ajanlott_ar != state.insurancePersonalGoods.allGoodsPrice
            )
              context.commit('setChosenPersonalPriceSide', labels.ingosagok_ajanlott_ar);
          }

          if (labels.result) {
            const save = labels.result;
            const dbDump = labels.result.dump;

            if (save.validation_code_base64) {
              if (save.validation_code_base64)
                context.commit('setEmailValidationCode', {
                  code: save.validation_code_base64,
                  email: state.contractSettings.email,
                });
            } else {
              if (save.id) context.commit('setStorageUid', labels.result.id);
              context.commit('setYearlyPrice', dbDump.alapdijosszesen || 0);
              context.commit('setPlusAccesoriesPrice', dbDump.eves_dij_plus || 0);
              context.commit('setFrequencyPrice', dbDump.gyakorisagdij || 0);
              context.commit('setMonthlyPrice', dbDump.havidij || 0);
              context.commit('setYearlyPriceWithAccesories', dbDump.eves_dij || 0);
              context.commit('setYearlyPriceWithDiscounts', dbDump.eves_dij_csokkentett || 0);
              if (dbDump?.engedmenyek) {
                const engedmenyek = dbDump.engedmenyek;

                if (engedmenyek.csoportos)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.csoportos;
                else if (engedmenyek.online)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.online;
                else if (engedmenyek.atutalas)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.atutalas;
                else if (engedmenyek.csekk) engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.csekk;
                else engedmenyek.fizetesi_mod_kedvezmeny = null;

                if (engedmenyek.eves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny = engedmenyek.eves;
                else if (engedmenyek.feleves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny = engedmenyek.feleves;
                else if (engedmenyek.negyedeves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny = engedmenyek.negyedeves;
                else engedmenyek.dijfizetes_gyakorisag_kedvezmeny = null;

                context.commit('setDiscounts', engedmenyek);
              }
              if (dbDump?.igeny_azon_href) {
                if (dbDump.igeny_azon_href !== context.igeny_azon_href) {
                  context.commit('setClaimIdentifierUrl', null);
                }
                context.commit('setClaimIdentifierUrl', dbDump.igeny_azon_href);
              } else {
                context.commit('setClaimIdentifierUrl', null);
              }
              if (dbDump?.PRODUCT_CODE) {
                context.commit('setProductCode', dbDump.PRODUCT_CODE);
              }
              if (dbDump?.risks) {
                context.commit('setRisks', dbDump.risks);
              }
              if (dbDump?.ertektargy_osszesen) {
                context.commit('setErtektargyOsszesen', dbDump.ertektargy_osszesen);
              }
              if (dbDump?.kedvezmenykod) {
                context.commit('setCouponCode', dbDump.kedvezmenykod);
              }
              if (dbDump?.partnertipus) {
                context.commit('setPartnertipus', dbDump.partnertipus);
              }
            }
          }
        }

        // console.log('verifyPage engedmeny utan: ');
        // console.log(result.data);
        // console.log('state engedmeny utan: ');
        // console.log(state);

        if (data.data) {
          data = result.data.data;
          // context.commit('setNextPageStatus', true);
          if (data.dm) {
            context.commit('setDmType', data.dm);
          }
          if (data.ertekesito_koti) {
            context.commit('setErtekesitoKoti', data.ertekesito_koti);
          }

          if (data.telepules) context.commit('setInsurancePropertyTownName', data.telepules);
          else context.commit('setInsurancePropertyTownName', 'Hibás irányítószám');

          if (data.ertektargy_max) context.commit('setMaxValuablesPrice', data.ertektargy_max);

          if (!state.contractorPropertyZipChanged) {
            if (data.szerzodo_levelezes_telepules) {
              context.commit('setContractPostPropertyTownName', data.szerzodo_levelezes_telepules);
            } else {
              context.commit('setContractPostPropertyTownName', 'Hibás irányítószám');
            }
            if (data.ph_city) {
              context.commit('setCompanyTownName', data.ph_city);
            } else {
              context.commit('setCompanyTownName', '');
            }
          }

          if (data.veglegesites_uzenet) {
            context.commit('setEndingMessageReceived', true);
            context.commit('setStorageUid', null);
            const message = data.veglegesites_uzenet;
            if (message.endsWith('.html')) {
              axios
                .get(message)
                .then((res) => {
                  if (res.data) {
                    Swal.fire({
                      icon: 'info',
                      html: res.data,
                      showCloseButton: true,
                      showConfirmButton: false,
                      closeButtonAriaLabel: 'x Ablak bezárása',
                      customClass: {
                        content: 'text-align-left',
                      },
                    });
                  }
                })
                .catch(() => {
                  Vue.$toast.error(
                    'Hiba történt a tartalom betöltése közben. Keressen fel minket valamelyik elérhetőségünkön.'
                  );
                });
            } else if (message.startsWith('http://') || message.startsWith('https://')) {
              context.commit('setProcessFinished', true);
              window.location = message;
            } else {
              Vue.$toast.info(message);
            }
          }
        }

        return Promise.resolve(result);
      } catch (err) {
        if (tab_id === 6) context.commit('setFormSubmitLoading', false);
        Vue.$toast.error(
          'Hiba történt a kapcsolat létrehozása közben. Kérjük keresse fel egyik munkatársunkat az info@colonnade.hu e-mail címen.'
        );

        return Promise.reject(err);
      }
      // console.log('storage_uid a verifyPage végén:' + context.state.storage_uid);
      // console.log('href a verifyPage végén:' + context.state.igeny_azon_href);
      //console.log('state');
      //console.log(this.state);
    },
    loadStateFromData(context, data) {
      const state = context.state;
      if (data.biztositas_targya) {
        let result = 1;
        if (data.biztositas_targya == 'ingatlan') result = 2;
        if (data.biztositas_targya == 'ingosag') result = 3;
        context.commit('setGeneralPropertyValues', {name: 'contractFor', value: result});
      }

      if (data.ingatlan_tipus)
        context.commit('setGeneralPropertyValues', {
          name: 'propertyType',
          value: data.ingatlan_tipus,
        });
      if ('allando_lakott' in data)
        context.commit('setGeneralPropertyValues', {
          name: 'propertyInhabitated',
          value: parseInt(data.allando_lakott),
        });
      if ('kulterulet' in data)
        context.commit('setGeneralPropertyValues', {
          name: 'propertyOutskirts',
          value: data.kulterulet ? 1 : 0,
        });
      if ('fizikai' in data)
        context.commit('setGeneralPropertyValues', {
          name: 'propertyPhysicalJob',
          value: data.fizikai ? 1 : 0,
        });
      //load from link propertyPhysicalJobName
      if ('fizikai_megnev' in data)
        context.commit('setGeneralPropertyValues', {
          name: 'propertyPhysicalJobName',
          value: data.fizikai_megnev,
        });
      if (data.tulajdonjog)
        context.commit('setGeneralPropertyValues', {
          name: 'propertyOwnRight',
          value: data.tulajdonjog,
        });
      if (data.iranyitoszam)
        context.commit('setGeneralPropertyValues', {
          name: 'propertyZip',
          value: data.iranyitoszam,
        });
      if (data.telepules)
        context.commit('setGeneralPropertyValues', {
          name: 'selectedPropertyName',
          value: data.telepules,
        });
      if (data.telepules) context.commit('setCityName', data.telepules);

      // insurance property
      if (data.alapterulet)
        context.commit('setInsurancePropertyValues', {
          name: 'floorArea',
          value: data.alapterulet,
        });
      if (data.epites_eve)
        context.commit('setInsurancePropertyValues', {name: 'builtYear', value: data.epites_eve});
      if (data.lakok_szama)
        context.commit('setInsurancePropertyValues', {
          name: 'residents',
          value: data.lakok_szama,
        });
      if (data.foepulet_falazat)
        context.commit('setInsurancePropertyValues', {
          name: 'wallType',
          value: data.foepulet_falazat,
        });
      if (data.foepulet_teto)
        context.commit('setInsurancePropertyValues', {
          name: 'roofType',
          value: data.foepulet_teto,
        });
      if (data.foepulet?.ajl_min_osszeg)
        context.commit('setInsurancePropertyValues', {
          name: 'recommendedInsurancePrice',
          value: data.foepulet.ajl_min_osszeg,
        });
      if (data.ingatlan_erteke) {
        context.commit('setInsurancePropertyValues', {
          name: 'chosenInsurancePrice',
          value: parseInt(data.ingatlan_erteke) || 0,
        });
        context.commit('setMainInsuranceChangedState', true);
      }

      // side buildings
      if (data.mellekepuletek) {
        const mellekepuletek = data.mellekepuletek;
        if (typeof mellekepuletek === 'string') {
          const buildings = data.mellekepuletek.split(';');
          buildings.forEach((building) => {
            const inputs = building.split(',');
            if (inputs.length > 1) {
              const inserted = Object.assign({}, state.insuranceSideBuildings.template);
              inputs.forEach((input) => {
                const split = input.split(':');
                if (split[0] == 'mellekepulet_alapterulet') inserted.floorArea = parseInt(split[1]);
                if (split[0] == 'mellekepulet_falazat') inserted.wallType = split[1];
                if (split[0] == 'mellekepulet_tetozet') inserted.roofType = split[1];
              });
              context.commit('addSideBuilding', inserted);
            }
          });
        } else if (typeof mellekepuletek === 'object') {
          mellekepuletek.forEach((sidebuilding) => {
            const inserted = Object.assign({}, state.insuranceSideBuildings.template);
            inserted.floorArea = sidebuilding.mellekepulet_alapterulet;
            inserted.wallType = sidebuilding.mellekepulet_falazat;
            inserted.roofType = sidebuilding.mellekepulet_teto;
            context.commit('addSideBuilding', inserted);
          });
        }
      }
      if (data.mellekepulet?.ajl_min_osszeg)
        context.commit('setInsuranceSidePropertyValues', {
          name: 'recommendedInsurancePrice',
          value: data.mellekepulet.ajl_min_osszeg,
        });
      if (data.valasztott_ar_mellekepulet) {
        context.commit('setInsuranceSidePropertyValues', {
          name: 'chosenInsurancePrice',
          value: parseInt(data.valasztott_ar_mellekepulet) || 0,
        });
        context.commit('setSideInsuranceChangedState', true);
      }

      // load from link - personal goods
      if ('ajanlott_bizt_osszeg_elfogad' in data)
        context.commit('setInsurancePersonalGoods', {
          name: 'acceptCalculatedInsurance',
          value: parseInt(data.ajanlott_bizt_osszeg_elfogad),
        });
      // personal goods
      if ('ingosag_intezmenyi_szamitas' in data)
        context.commit('setInsurancePersonalGoods', {
          name: 'acceptCalculatedInsurance',
          value: data.ingosag_intezmenyi_szamitas ? 1 : 0,
        });
      if (data.ingosag_osszesen)
        context.commit('setInsurancePersonalGoods', {
          name: 'allGoodsPrice',
          value: data.ingosag_osszesen,
        });
      if (data.haztartasigepek)
        context.commit('setInsurancePersonalGoodsInputs', {
          name: 'household',
          value: parseInt(data.haztartasigepek),
        });
      if (data.telekommunikacios_eszkozok)
        context.commit('setInsurancePersonalGoodsInputs', {
          name: 'telecom',
          value: parseInt(data.telekommunikacios_eszkozok),
        });
      if (data.butorok)
        context.commit('setInsurancePersonalGoodsInputs', {
          name: 'furniture',
          value: parseInt(data.butorok),
        });
      if (data.ruha_labbeli)
        context.commit('setInsurancePersonalGoodsInputs', {
          name: 'clothes',
          value: parseInt(data.ruha_labbeli),
        });
      if (data.konyhai_es_furdoszobai)
        context.commit('setInsurancePersonalGoodsInputs', {
          name: 'kitchen',
          value: parseInt(data.konyhai_es_furdoszobai),
        });
      if (data.textilek)
        context.commit('setInsurancePersonalGoodsInputs', {
          name: 'textile',
          value: parseInt(data.textilek),
        });
      if (data.egyeb)
        context.commit('setInsurancePersonalGoodsInputs', {
          name: 'other',
          value: parseInt(data.egyeb),
        });

      // other chooseable accesories
      if (data.ertektargy_osszesen)
        context.commit('setValuablesAboveInputs', {
          name: 'jewelry',
          value: parseInt(data.ertektargy_osszesen),
        });

      if (data.ekszerek)
        context.commit('setValuablesAboveInputs', {
          name: 'jewelry',
          value: parseInt(data.ekszerek),
        });
      if (data.antik_butorok)
        context.commit('setValuablesAboveInputs', {
          name: 'antiques',
          value: parseInt(data.antik_butorok),
        });
      //kepzomuveszeti
      if (data.kepzomuveszeti)
        context.commit('setValuablesAboveInputs', {
          name: 'fineart',
          value: parseInt(data.kepzomuveszeti),
        });
      if (data.szormek)
        context.commit('setValuablesAboveInputs', {
          name: 'exotic',
          value: parseInt(data.szormek),
        });
      if (data.gyujtemeny)
        context.commit('setValuablesAboveInputs', {
          name: 'collection',
          value: parseInt(data.gyujtemeny),
        });
      if (data.kiemeltingosag)
        context.commit('setChooseableAccesoriesSelected', {name: 'kiemeltingosag', value: true});
      if (data.ertektargy)
        context.commit('setChooseableAccesoriesSelected', {name: 'ertektargy', value: true});
      if (data.keszpenz)
        context.commit('setChooseableAccesoriesSelected', {name: 'keszpenz', value: true});
      if (data.kulonleges_uveg)
        context.commit('setChooseableAccesoriesSelected', {name: 'kulonleges_uveg', value: true});
      if (data.epites)
        context.commit('setChooseableAccesoriesSelected', {name: 'epites', value: true});
      if (data.assistance)
        context.commit('setChooseableAccesoriesSelected', {name: 'assistance', value: true});
      if (data.fagyasztott_etel_romlas)
        context.commit('setChooseableAccesoriesSelected', {
          name: 'fagyasztott_etel_romlas',
          value: true,
        });
      if (data.szabadban_tarolt)
        context.commit('setChooseableAccesoriesSelected', {name: 'szabadban_tarolt', value: true});
      if (data.kerti_butor)
        context.commit('setChooseableAccesoriesSelected', {name: 'kerti_butor', value: true}); // átnevezni, de mire ???
      if (data.sporteszkoz)
        context.commit('setChooseableAccesoriesSelected', {name: 'sporteszkoz', value: true});
      if (data.kegyeleti)
        context.commit('setChooseableAccesoriesSelected', {name: 'kegyeleti', value: true});
      if (data.kegyeleti_biztositas)
        context.commit('setChooseableAccesoriesSelected', {
          name: 'kegyeleti_biztositas',
          value: true,
        });
      if (data.baleset)
        context.commit('setChooseableAccesoriesSelected', {name: 'baleset', value: true});
      if (data.utasbiztositas)
        context.commit('setChooseableAccesoriesSelected', {name: 'utasbiztositas', value: true});
      if (data.felelosseg)
        context.commit('setChooseableAccesoriesSelected', {name: 'felelosseg', value: true});
      if (data.vizkarextra)
        context.commit('setChooseableAccesoriesSelected', {name: 'vizkarextra', value: true});
      if (data.vandalizmus)
        context.commit('setChooseableAccesoriesSelected', {name: 'vandalizmus', value: true});
      if (data.mezogazdasag)
        context.commit('setChooseableAccesoriesSelected', {name: 'mezogazdasag', value: true});
      if (data.kerti_veszelytelenites)
        context.commit('setChooseableAccesoriesSelected', {
          name: 'kerti_veszelytelenites',
          value: true,
        });
      if (data.zoldenergia)
        context.commit('setChooseableAccesoriesSelected', {
          name: 'zoldenergia',
          value: true,
        });

      if (data.balesetbiztositas_tipusa)
        context.commit('setChooseableAccesories', {
          name: 'accidentInsuranceType',
          value: data.balesetbiztositas_tipusa,
        });

      if (data.kiemeltingosag_osszeg)
        context.commit('setChooseableAccesories', {
          name: 'priorityProperty',
          value: data.kiemeltingosag_osszeg,
        });
      if (data.kiemeltingosag_osszeg)
        context.commit('setChooseableAccesories', {
          name: 'priorityProperty',
          value: data.kiemeltingosag_osszeg,
        });
      if (data.berloi_felelosseg)
        context.commit('setChooseableAccesories', {
          name: 'landlordLiability',
          value: true,
        });
      //mezogazdasagi
      if (data.termes_termeny)
        context.commit('setChooseableAccesories', {
          name: 'farmingStock',
          value: parseInt(data.termes_termeny),
        });
      if (data.allatallomany)
        context.commit('setChooseableAccesories', {
          name: 'farmingAnimals',
          value: parseInt(data.allatallomany),
        });
      if (data.gepek_felszereles)
        context.commit('setChooseableAccesories', {
          name: 'farmingTools',
          value: parseInt(data.gepek_felszereles),
        });
      if (data.kegyeleti_tipusa)
        context.commit('setChooseableAccesories', {
          name: 'funeralPrice',
          value: parseInt(data.kegyeleti_tipusa),
        });

      // insured persons utas
      if (data.utas_biztositottak) {
        const persons = data.utas_biztositottak.split(';');
        persons.forEach((person) => {
          const inputs = person.split(',');
          if (inputs.length > 1) {
            const inserted = Object.assign({}, state.chooseableAccesories.personTemplate);
            inputs.forEach((input) => {
              const split = input.split(':');
              if (split[0] == 'nev') inserted.name = split[1];
              if (split[0] == 'szuletesi_datum') inserted.bornDate = split[1];
            });
            context.commit('addInsuredPerson', {person: inserted, listName: 'travelInsuranced'});
          }
        });
      }
      // insured persons kegyeleti
      if (data.temetes_biztositottak) {
        const persons = data.temetes_biztositottak.split(';');
        persons.forEach((person) => {
          const inputs = person.split(',');
          if (inputs.length > 1) {
            const inserted = Object.assign({}, state.chooseableAccesories.personTemplate);
            inputs.forEach((input) => {
              const split = input.split(':');
              if (split[0] == 'nev') inserted.name = split[1];
              if (split[0] == 'szuletesi_datum') inserted.bornDate = split[1];
            });
            context.commit('addInsuredPerson', {person: inserted, listName: 'burialInsuranced'});
          }
        });
      }

      // payment data
      if (data.dijfizetes_mod)
        context.commit('setPaymentOptions', {name: 'type', value: data.dijfizetes_mod});
      if (data.dijfizetes_gyakorisag)
        context.commit('setPaymentOptions', {
          name: 'frequency',
          value: data.dijfizetes_gyakorisag,
        });
      if ('ekommunikacio' in data)
        context.commit('setElectronicContact', parseInt(data.ekommunikacio));
      if ('ekarrendezes' in data)
        context.commit('setElectronicInsuring', parseInt(data.ekarrendezes));
      if ('eletkorkedvezmeny' in data)
        context.commit('setAgeDiscount', parseInt(data.eletkorkedvezmeny));
      if (data.kotes_oka) context.commit('setContraceReason', data.kotes_oka);
      if (data.regi_kotvenyszam) context.commit('setOldBondnumber', data.regi_kotvenyszam);
      // 4th page data
      if (data.kockazat_kezdete)
        context.commit('updateRiskSettings', {
          name: 'startDate',
          value: data.kockazat_kezdete,
        });
      if (data.kozterulet)
        context.commit('updateRiskSettings', {name: 'locationName', value: data.kozterulet});
      if (data.kozterulet_jellege)
        context.commit('updateRiskSettings', {
          name: 'locationType',
          value: data.kozterulet_jellege,
        });
      if (data.hazszam)
        context.commit('updateRiskSettings', {name: 'locationHouseNumber', value: data.hazszam});
      if (data.kockazat_epl)
        context.commit('updateRiskSettings', {
          name: 'locationBuilding',
          value: data.kockazat_epl,
        });
      if (data.kockazat_helyrajzi_szam)
        context.commit('updateRiskSettings', {
          name: 'locationTopography',
          value: data.kockazat_helyrajzi_szam,
        });

      if (data.szerzodo_vezeteknev)
        context.commit('updateContractSettings', {
          name: 'lastName',
          value: data.szerzodo_vezeteknev,
        });
      if (data.szerzodo_keresztnev)
        context.commit('updateContractSettings', {
          name: 'firstName',
          value: data.szerzodo_keresztnev,
        });
      if (data.szerzodo_anyja_leanykori_nev)
        context.commit('updateContractSettings', {
          name: 'motherChildName',
          value: data.szerzodo_anyja_leanykori_nev,
        });
      if (data.szerzodo_szuletes_nev)
        context.commit('updateContractSettings', {
          name: 'bornName',
          value: data.szerzodo_szuletes_nev,
        });
      if (data.szerzodo_szuletesi_hely)
        context.commit('updateContractSettings', {
          name: 'bornCity',
          value: data.szerzodo_szuletesi_hely,
        });
      if (data.szerzodo_szuletesi_datum)
        context.commit('updateContractSettings', {
          name: 'bornDate',
          value: data.szerzodo_szuletesi_datum,
        });
      //Ezt nem töltjük vissza, hogy ne menjen az email a link után, és ne engedje tovább úgy hogy nincs érvényes kód
      if (data.szerzodo_email)
        context.commit('updateContractSettings', {name: 'email', value: data.szerzodo_email});
      // if (data.szerzodo_email_2)
      //   context.commit('updateContractSettings', {
      //     name: 'emailVerification',
      //     value: data.szerzodo_email_2,
      //   });
      if (data.szerzodo_telefonszam_korzet)
        context.commit('updateContractSettings', {
          name: 'phoneNumberArea',
          value: data.szerzodo_telefonszam_korzet,
        });
      if (data.szerzodo_telefonszam)
        context.commit('updateContractSettings', {
          name: 'phoneNumber',
          value: data.szerzodo_telefonszam,
        });

      if (data.szerzodo_levelezes_egyezik)
        context.commit('updateContractSettings', {
          name: 'postAddressIsTheSame',
          value: parseInt(data.szerzodo_levelezes_egyezik),
        });

      if (data.szerzodo_levelezes_irsz)
        context.commit('updateContractPostSettings', {
          name: 'locationZip',
          value: data.szerzodo_levelezes_irsz,
        });
      if (data.szerzodo_levelezes_telepules)
        context.commit('updateContractPostSettings', {
          name: 'locationCity',
          value: data.szerzodo_levelezes_telepules,
        });
      if (data.szerzodo_levelezes_kozterulet)
        context.commit('updateContractPostSettings', {
          name: 'locationName',
          value: data.szerzodo_levelezes_kozterulet,
        });
      if (data.szerzodo_levelezes_jelleg)
        context.commit('updateContractPostSettings', {
          name: 'locationType',
          value: data.szerzodo_levelezes_jelleg,
        });
      if (data.szerzodo_levelezes_hazszam)
        context.commit('updateContractPostSettings', {
          name: 'locationHouseNumber',
          value: data.szerzodo_levelezes_hazszam,
        });
      if (data.szerzodo_levelezes_epl)
        context.commit('updateContractPostSettings', {
          name: 'locationBuilding',
          value: data.szerzodo_levelezes_epl,
        });

      if (data.szerzodo_biztositott)
        context.commit('updateInsuredSettings', {
          name: 'contractedIsInsured',
          value: parseInt(data.szerzodo_biztositott),
        });
      if (data.biztositott_vezeteknev)
        context.commit('updateInsuredSettings', {
          name: 'lastName',
          value: data.biztositott_vezeteknev,
        });
      if (data.biztositott_keresztnev)
        context.commit('updateInsuredSettings', {
          name: 'firstName',
          value: data.biztositott_keresztnev,
        });
      if (data.biztositott_anyja_leanykori_nev)
        context.commit('updateInsuredSettings', {
          name: 'motherChildName',
          value: data.biztositott_anyja_leanykori_nev,
        });
      if (data.biztositott_szuletes_nev)
        context.commit('updateInsuredSettings', {
          name: 'bornName',
          value: data.biztositott_szuletes_nev,
        });
      if (data.biztositott_szuletesi_hely)
        context.commit('updateInsuredSettings', {
          name: 'bornCity',
          value: data.biztositott_szuletesi_hely,
        });
      if (data.biztositott_szuletett)
        context.commit('updateInsuredSettings', {
          name: 'bornDate',
          value: data.biztositott_szuletett,
        });
      if (data.biztositott_telefonszam_korzet)
        context.commit('updateInsuredSettings', {
          name: 'phoneNumberArea',
          value: data.biztositott_telefonszam_korzet,
        });
      if (data.biztositott_telefonszam)
        context.commit('updateInsuredSettings', {
          name: 'phoneNumber',
          value: data.biztositott_telefonszam,
        });
      if (data.biztositott_email)
        context.commit('updateInsuredSettings', {name: 'email', value: data.biztositott_email});

      if (data.ingatlan_jelzalog)
        context.commit('updateMortgageSettings', {
          name: 'propertyIsMortgaged',
          value: parseInt(data.ingatlan_jelzalog),
        });
      if (data.jelzalog_hitelezo_nev)
        context.commit('updateMortgageSettings', {
          name: 'creditor',
          value: data.jelzalog_hitelezo_nev,
        });
      if (data.jelzalog_hitelezo_szekhely)
        context.commit('updateMortgageSettings', {
          name: 'creditorLocation',
          value: data.jelzalog_hitelezo_szekhely,
        });
      if (data.jelzalog_azonosito)
        context.commit('updateMortgageSettings', {
          name: 'mortgageId',
          value: data.jelzalog_azonosito,
        });
      if (data.jelzalog_hitel_osszeg)
        context.commit('updateMortgageSettings', {
          name: 'mortgagePrice',
          value: parseInt(data.jelzalog_hitel_osszeg),
        });

      if (data.kotes_oka) context.commit('setContraceReason', data.kotes_oka);
      if (data.regi_kotvenyszam) context.commit('setOldBondnumber', data.regi_kotvenyszam);
      // statements
      if (data.nyilatkozatok) {
        const nyilatkozatok = data.nyilatkozatok;
        if (nyilatkozatok.includes('adatvedelmi_nyilatkozat'))
          context.commit('updateStatements', {
            name: 'privacyStatement',
            value: true,
          });
        if (nyilatkozatok.includes('atkonyveles_nyilatkozat'))
          context.commit('updateStatements', {
            name: 'contrctReasonStatement',
            value: true,
          });
        if (nyilatkozatok.includes('biztositasi_feltetelek'))
          context.commit('updateStatements', {
            name: 'insuranceTerms',
            value: true,
          });
        if (nyilatkozatok.includes('hirlevel'))
          context.commit('updateStatements', {name: 'marketingMails', value: true});
      }

      setTimeout(() => {
        context.commit('setMFOLoadedStatus', true);
      }, 1000);
    },

    updateMarks(context, marks) {
      if (!marks) {
        marks = context.state.marks;
      }

      const validUrl = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i'
      );

      for (let [key, value] of Object.entries(marks)) {
        if (validUrl.test(value)) {
          //this.$http.get(value).then(response => {
          //this.html = response.data;
          //if(response.data) value = response.data
          //});
          //axios.get(value).then(res => {
          //if(res.data) value = res.data
          //})
        }
        if (key === 'mellek_alapterulet' || key === 'mellek_falazat' || key === 'mellek_tetozet') {
          const elements = document.querySelectorAll(`[data-tooltip="${key}"]`);
          elements.forEach((element) => {
            element.addEventListener('click', () => {
              Swal.fire({
                icon: 'question',
                html: value,
                showCloseButton: true,
                showConfirmButton: false,
                closeButtonAriaLabel: 'x Ablak bezárása',
                customClass: {
                  content: 'text-align-left',
                },
              });
            });
          });
        } else if (key === 'csillag') {
          document.getElementById('invalid_inputs').innerHTML = value;
        } else if (key.includes('fed')) {
          const elements = document.getElementsByName(`${key}-tooltip`);
          Array.from(elements).forEach(addListener);
          function addListener(elem) {
            if (elem) {
              elem.addEventListener('click', (event) => {
                Swal.fire({
                  icon: 'question',
                  html: value,
                  showCloseButton: true,
                  showConfirmButton: false,
                  closeButtonAriaLabel: 'x Ablak bezárása',
                  customClass: {
                    content: 'text-align-left',
                  },
                });
                event.stopPropagation();
              });
            }
          }
        } else {
          const element = document.getElementById(`${key}-tooltip`);
          if (element) {
            element.addEventListener('click', () => {
              Swal.fire({
                icon: 'question',
                html: value,
                showCloseButton: true,
                showConfirmButton: false,
                closeButtonAriaLabel: 'x Ablak bezárása',
                customClass: {
                  content: 'text-align-left',
                },
              });
            });
          }
        }
      }
    },
    navigateToSaveUrl(context, fetch_uid) {
      let currentLocation = window.location;
      if (currentLocation.search) {
        // window.location.href =
        //   currentLocation.origin + '/' + currentLocation.search + '&fetch_uid=' + fetch_uid;
        window.location.href = replaceUrlParam(currentLocation.href, 'fetch_uid', fetch_uid);
      } else {
        window.location.href = currentLocation.origin + '/?fetch_uid=' + fetch_uid;
      }
    },
    createFetchURL(context, fetch_uid) {
      let currentLocation = window.location;
      let fetchUrl = '';
      if (currentLocation.search) {
        fetchUrl = replaceUrlParam(currentLocation.href, 'fetch_uid', fetch_uid);
      } else {
        fetchUrl = currentLocation.origin + '/?fetch_uid=' + fetch_uid;
      }
      context.commit('setFetchUrl', fetchUrl);
    },
    getSavedDataByUid(context, fetch_uid) {
      context.commit('setNextPageStatus', false);
      const params = new URLSearchParams();
      params.append('fetch_sr', fetch_uid);
      //params.append('marks', 1);

      //console.log(`MFO lekérés – ${mfo_uid}`)
      axios
        .get(
          `${window.eqform.baseURL}/eqformexecutor/fetch_sr/${window.eqform.formID}/${fetch_uid}`,
          {
            headers: {
              Accept: '*/*',
              //'access-control-allow-origin': '*',
            },
          }
        )
        .then((res) => {
          if (res.statusText == 'OK') {
            const data = res.data.result.message;
            const filteredData = removeUnusedPropertyFromSaveData(data, saveDataDefaultValues);
            context.dispatch('loadStateFromData', filteredData);
            context.commit('setNextPageStatus', true);
            context.commit('setGenerateLink', 0);
            // const ZipData = context.cities[context.generalInfo.propertyZip];
            // let cityNames =
            //   typeof zipData.telepules === 'string'
            //     ? [zipData.telepules]
            //     : Object.values(zipData.telepules);
            // let cityName = '';
            // if (this.cityNames.length === 1) {
            //   cityName = this.cityNames[0];
            // }
            // context.commit('setCityName', cityName);
          }
        })
        .catch((error) => {
          console.error('Édes Otthon kommunikációs hiba.');
          //console.log('Error', error.message);
          //Vue.$toast.error('Kommunikációs hiba.')
          //context.commit('setGenerateLink', 0);
          context.commit('setGenerateLink', 0);
        });
    },
    getMFOData(context, mfo_uid) {
      context.commit('setNextPageStatus', false);

      const params = new URLSearchParams();
      params.append('mfo_uid', mfo_uid);
      //console.log(`MFO lekérés – ${mfo_uid}`)

      return axios
        .get('https://coltest.nopa.hu/eqform/mnb/mfo/get/' + mfo_uid, {
          headers: {
            Accept: '*/*',
          },
        })
        .then((res) => {
          const data = res.data?.inputData;
          data.mfo_uid = mfo_uid;

          // if (data) {
          //   context.dispatch('loadStateFromData', data);

          //   context.commit('setNextPageStatus', true);
          // }
        })
        .catch(() => {
          console.error('MFO kommunikációs hiba.');
          //Vue.$toast.error('Kommunikációs hiba.')
        });
    },
    async getSelectLists(context) {
      const apiUrl = `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`;
      const params = new URLSearchParams();

      params.append('code', 'listofcities');

      const cityData = await axios.post(apiUrl, params);
      const cities = cityData?.data?.data?.listofcities ?? [];

      await context.commit('setCities', cities);
    },
  },
});
